angular.module('app.controllers.find_a_builder', [])
  .controller('FindABuilderController', ['$rootScope','$scope','$log', function ($rootScope, $scope, $log) {

  'use strict';
   angular.module('app', [
    'ui.bootstrap'
    ]);
  $log.debug('FindABuilderController()');

    $scope.rows = [
      { AZname: 'Avatar Homes/Joseph Carl Homes', AZlink:'',
        NVname: 'Distinctive Homes', NVlink:'',
        CAname: 'KB Homes', CAlink:'' }

      ,{ AZname: 'Ashton Woods Homes', AZlink:'',
        NVname: 'Dunhill Homes', NVlink:'',
        CAname: 'D./R. Horton', CAlink:'' }

      ,{ AZname: 'Beazer Homes', AZlink:'',
        NVname: 'KB Homes', NVlink:'',
        CAname: '', CAlink:'' }

      ,{ AZname: 'Cachet Homes', AZlink:'',
        NVname: '', NVlink:'',
        CAname: '', CAlink:'' }

      ,{ AZname: 'Avatar Homes/Joseph Carl Homes', AZlink:'',
        NVname: '', NVlink:'',
        CAname: '', CAlink:'' }
      ];
      
      $scope.subjects = ['Arizona', 'Nevada', 'California'];
      $scope.selectedItem = "Arizona";
      $scope.dropboxitemselected = function (item) {
 
        $scope.selectedItem = item;

       

     if($scope.selectedItem=="Arizona"){
          document.getElementById('arizona').style.display = 'inline';
          document.getElementById('nevada').style.display = 'none';
          document.getElementById('california').style.display = 'none';
          }else if($scope.selectedItem=="Nevada"){
          document.getElementById('arizona').style.display = 'none';
          document.getElementById('nevada').style.display = 'inline';
          document.getElementById('california').style.display = 'none';
          }else{
          document.getElementById('arizona').style.display = 'none';
          document.getElementById('nevada').style.display = 'none';
          document.getElementById('california').style.display = 'inline';
          }   
        
    };


}]);

